<template>
  <svg :width="width"
       :height="height"
       fill="none"
       viewBox="0 0 76 76"
       role="presentation"
       @click="$emit('click')">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M52.277 5.362H24.723a2.362 2.362 0 0 0-2.361 2.361v61.405a2.362 2.362 0 0 0 2.361 2.361h27.554a2.362 2.362 0 0 0 2.361-2.361V7.723a2.362 2.362 0 0 0-2.361-2.361zM24.723 3A4.723 4.723 0 0 0 20 7.723v61.405a4.723 4.723 0 0 0 4.723 4.723h27.554A4.723 4.723 0 0 0 57 69.128V7.723A4.723 4.723 0 0 0 52.277 3H24.723z" fill="#8067B7"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M34.17 8.51c0-.434.353-.786.788-.786h7.085a.787.787 0 0 1 0 1.574h-7.085a.787.787 0 0 1-.788-.787zM38.5 69.128a1.968 1.968 0 1 0 0-3.936 1.968 1.968 0 0 0 0 3.936zm0 1.574a3.543 3.543 0 1 0 0-7.085 3.543 3.543 0 0 0 0 7.085zM55.426 13.234H21.575V11.66h33.85v1.574zM55.426 62.043H21.575v-1.575h33.85v1.575zM30.282 28.144a1.18 1.18 0 0 1 1.67 0L47.6 43.793a1.18 1.18 0 0 1-1.67 1.67l-15.65-15.65a1.181 1.181 0 0 1 0-1.67z" fill="#8067B7"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M47.601 28.24a1.18 1.18 0 0 1 0 1.67l-15.65 15.648a1.181 1.181 0 0 1-1.67-1.67l15.65-15.649a1.18 1.18 0 0 1 1.67 0z" fill="#8067B7"/>
  </svg>  
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>